export default __webpack_public_path__ + "static/media/Chainsulting-Audit-Icon-739x700.5aa7364d.png";